import React from 'react'
import styled from 'styled-components'
import {REGEX_MULTIPLE_NEWLINES} from 'consts'
import {formatDateRange} from 'utils'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {FototreeDetailContentExtraProps} from './FototreeContentProps'

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${convertUnit(4)};
`

const StyledBio = styled(Paragraph)`
  word-break: break-word;
  white-space: pre-wrap;
  line-height: ${convertUnit(18)};
`

export default function FototreeDetailContentExtra({
  data: {bio, event_end_date, event_start_date, sub_category},
  fontWeight = 'bold',
  color = 'white_1',
}: FototreeDetailContentExtraProps) {
  const hasDateRange = event_start_date && event_end_date
  const isValidSubcategory = !['Other', 'Community'].includes(sub_category)

  return (
    <>
      {(hasDateRange || isValidSubcategory) && (
        <StyledContainer>
          <Icon size={16} type="event" color={color} />
          <Paragraph color={color} fontWeight={fontWeight}>
            {isValidSubcategory && sub_category}
            {isValidSubcategory && hasDateRange && '  |  '}
            {hasDateRange && formatDateRange(event_start_date, event_end_date)}
          </Paragraph>
        </StyledContainer>
      )}
      <StyledBio color={color}>
        {bio.replace(REGEX_MULTIPLE_NEWLINES, '\n')}
      </StyledBio>
    </>
  )
}
